import React from 'react';
import { NavLink } from 'react-router-dom';

const AddProspectCrumb = () => <NavLink to="/human-resources/prospects/add">Add Prospect</NavLink>;

export default AddProspectCrumb;
